angular.module('leanlaw').controller('CodesBillablesDetailSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };
  $scope.filter.include.matters = false;
  // $scope.filter.include.accounting = false;

  // Fires immediately on filter creation
  $scope.$watch("filter", (newValue, oldValue) => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);